import React from "react";
import { Link } from "react-router-dom";
import {
  ReprocessDataTaskStatus,
  useReprocessDataTasksQuery,
} from "../../graphql/generated";
import Panel from "../../common/components/panel";
import LoadingIcon from "../../common/components/loadingicon";
import ReprocessDataTaskTable from "../../reprocess-data-task/components/table";

const ReprocessDataTasksPanel: React.FC<{
  ids?: string[];
  statuses?: ReprocessDataTaskStatus[];
  limit?: number;
}> = ({ ids, statuses, limit }) => {
  const [{ data, error, fetching }] = useReprocessDataTasksQuery({
    variables: {
      mlsResourceIds: ids,
      statuses,
      limit,
    },
  });

  return (
    <Panel>
      <Panel.Title>
        Active reprocess tasks{" "}
        <Link
          to="/reprocess_data_tasks"
          className="text-xs text-gray text-underline"
        >
          View all »
        </Link>
      </Panel.Title>
      <Panel.Body>
        {fetching && <LoadingIcon />}
        {error && <div className="text-red-500">Failed to load details</div>}
        {data && <ReprocessDataTaskTable tasks={data.reprocessDataTasks} />}
      </Panel.Body>
    </Panel>
  );
};

export default ReprocessDataTasksPanel;
